export const GET_REFERRALS = 'Get_Referrals';